import { render, staticRenderFns } from "./resellersV2.vue?vue&type=template&id=b0da26b2&"
import script from "./resellersV2.vue?vue&type=script&lang=js&"
export * from "./resellersV2.vue?vue&type=script&lang=js&"
import style0 from "./resellersV2.vue?vue&type=style&index=0&id=b0da26b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports